import React from 'react';
import { Grid, Box, MenuItem, TextField } from '@mui/material';
import TransformationBase from './common/TransformationBase';
import { TransformationHeading } from './common/fields/Heading';
import { COMMON_STYLES, COMMON_VALIDATION, COMMON_VALIDATION_PARAM } from './common/Constants';
import { SourceColumnField } from './common/fields/SourceColumnField';
import { OutputColumnField } from './common/fields/OutputColumnField';
import { CheckBoxField } from './common/fields/CheckBoxField';
import TransformationArrayField from './common/fields/TransformationArrayField';

const INITIALSTATE = {
  type: 'to_date',
  alias: '',
  df: '',
  transformations: [
    {
      sourceColumns: [''],
      outputColumn: '',
      param: 'yyyy-MM-dd',
      transformInPlace: false,
    },
  ],
};

const dateFormatOptions = [
  { value: 'yyyy-MM-dd', label: 'yyyy-MM-dd' },
  { value: 'MM/dd/yyyy', label: 'MM/dd/yyyy' },
  { value: 'dd-MM-yyyy', label: 'dd-MM-yyyy' },
];

const validationSchema = {
  ...COMMON_VALIDATION,
  ...COMMON_VALIDATION_PARAM('Date format is required'),
};

const renderTransformationFields = ({ formField, errors, setFieldValue, disableForm, headers }) => {
  const handleInPlaceChange = (index, value) => {
    const newTransforms = [...formField.transformations];
    newTransforms[index].transformInPlace = value;
    if (value) {
      newTransforms[index].outputColumn = '';
    }
    setFieldValue('transformations', newTransforms);
  };

  const renderField = ({ transform, index, headers, disableForm, errors }) => {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CheckBoxField
              checked={transform.transformInPlace}
              onChange={(value) => handleInPlaceChange(index, value)}
              disabled={disableForm}
            />
          </Grid>

          <Grid item {...COMMON_STYLES.gridItem}>
            <SourceColumnField
              helperText={
                errors?.sourceColumns ||
                (transform.transformInPlace
                  ? 'This column will be converted to date directly'
                  : 'Select text column containing date strings')
              }
              value={transform.sourceColumns?.[0] || ''}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].sourceColumns = [e.target.value];
                setFieldValue('transformations', newTransforms);
              }}
              headers={headers}
              disabled={disableForm}
              error={!!errors.sourceColumns}
            />
          </Grid>
          <Grid item {...COMMON_STYLES.gridItem}>
            <TextField
              select
              fullWidth
              label="Date Format *"
              size="small"
              value={transform.param}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].param = e.target.value;
                setFieldValue('transformations', newTransforms);
              }}
              disabled={disableForm}
              error={!!errors.param}
              helperText={errors?.param || 'Select the format of your date strings'}
            >
              {dateFormatOptions.map((format) => (
                <MenuItem key={format.value} value={format.value}>
                  {format.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {!transform.transformInPlace && (
            <Grid item {...COMMON_STYLES.gridItem}>
              <OutputColumnField
                value={transform.outputColumn}
                onChange={(e) => {
                  const newTransforms = [...formField.transformations];
                  newTransforms[index].outputColumn = e.target.value;
                  setFieldValue('transformations', newTransforms);
                }}
                disabled={disableForm}
                error={!!errors?.outputColumn}
                helperText={errors?.outputColumn || 'Enter output column name'}
              />
            </Grid>
          )}
        </Grid>
      </>
    );
  };
  return (
    <Box sx={COMMON_STYLES.container}>
      <TransformationHeading title='To Date - Convert string to date ("2023-01-01" → Date)' disabled={disableForm} />
      <TransformationArrayField
        transformations={formField.transformations}
        setTransformations={(newTransforms) => setFieldValue('transformations', newTransforms)}
        renderField={renderField}
        errors={errors.transformations || []}
        headers={headers}
        disableForm={disableForm}
      />
    </Box>
  );
};

const NodeModal_ToDate = (props) => (
  <TransformationBase
    {...props}
    INITIALSTATE={INITIALSTATE}
    validationSchema={validationSchema}
    renderTransformationFields={renderTransformationFields}
    transformationType={INITIALSTATE.type}
    tranformationName="To Date"
  />
);

export default NodeModal_ToDate;
